module.exports = __webpack_public_path__ + "static/tooltip1-cbf3d04b566a8ca4cf14556e059746bf.png";